import { render, staticRenderFns } from "./LoginCardAuthorizationOverview.vue?vue&type=template&id=091d727d"
import script from "./LoginCardAuthorizationOverview.vue?vue&type=script&lang=ts"
export * from "./LoginCardAuthorizationOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports